import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { IconComponent, SectionLinkDirective } from '../../shared';
import { FOOTER } from '../../content/home.content';

@Component({
  selector: 'app-footer',
  imports: [RouterLink, IconComponent, SectionLinkDirective],
  templateUrl: './footer.component.html'
})
export class FooterComponent {
  readonly content = FOOTER;
  readonly currentYear = new Date().getFullYear();
}
